import { useMutation, useQueryClient } from "react-query";
import updateUserProfileV1 from "../../../components/api/mutations/updateUserProfileV1";
import { QUERY_KEYS } from '../constants/queryKeys';

export const useChangeProfileMutation = () => {
	const queryClient = useQueryClient();

	const { mutate: changeProfileMutation, isLoading } = useMutation(
		updateUserProfileV1,
		{
			onSuccess: () => {
				queryClient.invalidateQueries(QUERY_KEYS.USERS);
			},
		},
	);

	return {
		changeProfileMutation,
		isLoading,
	};
};
